import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ComponentFactoryResolver,
	EventEmitter,
	Input,
	OnDestroy,
	Output,
	ViewChild,
	ViewContainerRef,
	ViewEncapsulation,
} from "@angular/core";
import { Subscription } from "rxjs";

import { FlowStepConfig } from "../flow.model";

@Component({
	selector: "obg-login-flow-step-renderer",
	templateUrl: "./flow-step-renderer.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class FlowStepRendererComponent implements AfterViewInit, OnDestroy {
	@ViewChild("flowStep", { read: ViewContainerRef }) flowStepVcr!: ViewContainerRef;
	@Input() item: FlowStepConfig | undefined;
	@Output() navigate = new EventEmitter();

	private events$$: Subscription | undefined;

	constructor(
		private cfr: ComponentFactoryResolver,
		private changeDetector: ChangeDetectorRef
	) {}

	ngAfterViewInit() {
		if (!this.item?.component) {
			return;
		}
		this.flowStepVcr.clear();
		const componentFactory = this.cfr.resolveComponentFactory(this.item.component);
		const componentRef = this.flowStepVcr.createComponent<
			Component & { nextStep?: EventEmitter<number | undefined> }
		>(componentFactory);
		this.events$$ = componentRef.instance.nextStep?.subscribe(() => this.navigate.emit());
		this.changeDetector.markForCheck();
		this.changeDetector.detectChanges();
	}

	ngOnDestroy(): void {
		this.events$$?.unsubscribe();
	}
}
